var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67006 11.4797L9.216 6.84192H10.1647L11.7106 11.4797L16.3485 13.0257V13.9744L11.7106 15.5203L10.1647 20.1581H9.216L7.67006 15.5203L3.03223 13.9744V13.0257L7.67006 11.4797Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4201 5.22975L17.216 2.84192H18.1647L18.9606 5.22975L21.3485 6.02569V6.97437L18.9606 7.77032L18.1647 10.1581H17.216L16.4201 7.77032L14.0322 6.97437V6.02569L16.4201 5.22975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.690ba20c07fc2f4c90c347d1a9f3851f.svg";
export { ForwardRef as ReactComponent };